import { h, Component } from 'preact';
import * as jsonPointer from 'utils/jsonPointer';

import Button from 'components/button/button';

import s from 'components/editor/content.sss';

export default class EditorContent extends Component {
	constructor(props) {
		super(props);

		this.selectParentLevel = this.selectParentLevel.bind(this);
	}

	selectParentLevel() {
		const activeElement = this.props.activeElement;
		if (!activeElement) return;
		const path = jsonPointer.parse(activeElement);
		path.pop();
		const newPath = !path.length ? null : jsonPointer.compile(path);
		this.props.select(newPath);
	}

	renderVisual() {}

	renderSettingsNavigation(nav) {
		if (!nav?.length) return;
		return (
			<div class={s.settingsNavigation} key="settings-navigation">
				<div class={s.path}>
					{nav.slice(0, -1).flatMap(e => [<button onClick={() => this.props.select(e.path)}>{e.label}</button>, <span class={s.sep} />])}
					<span class={s.current}>{nav.at(-1)?.label}</span>
				</div>
				{nav.length > 1 && <Button class={s.back} dark outline icon="chevron-left" onClick={() => this.props.select(nav.at(-2).path)}>Back</Button>}
			</div>
		);
	}

	renderSettings() {}

	render(props) {
		if (props.visual) {
			return this.renderVisual();
		}
		if (props.settings) {
			return this.renderSettings();
		}
	}
}